import styled from "styled-components";

const Heading = styled.h1`
  text-align: center;
`;

export default Heading;



// WEBPACK FOOTER //
// ./src/reusables/Heading.js